<script lang="ts">
  import Modal from '$lib/components/styled/Modal.svelte';
  import {saveSettingsFlow} from '$lib/flows/saveSettingsFlow';
  import {allSettings, currentSettings, currentSettingsState} from '$lib/state/settings';
</script>

<h1 class="font-black text-red-500 text-4xl">WARNING: game's rule set</h1>

<div>
  <h1 class="font-black text-4xl">Settings</h1>
  <span class="m-2 inline-block"
    >Name: <input class="bg-slate-200" bind:value={$currentSettings.name} type="text" /></span
  >
  {#if !$currentSettingsState.inList || $currentSettingsState.changed}
    <button class="border-2 border-black p-2" on:click={() => saveSettingsFlow.save()}>Save</button>
    {#if $currentSettingsState.inList}
      <button class="border-2 border-black p-2" on:click={() => allSettings.reset()}>Reset</button>
    {/if}
  {/if}
</div>
<h2 class="font-bold text-xl">Base cards</h2>
{#each $currentSettings.baseCardSets as baseCardSet, i}
  <h3 class="font-bold">Set {i}:</h3>
  {#each baseCardSet as _, j}
    attack <input class="w-9" bind:value={$currentSettings.baseCardSets[i][j].attack} type="number" />
    defense <input class="w-9" bind:value={$currentSettings.baseCardSets[i][j].defense} type="number" />
    strength <input class="w-9" bind:value={$currentSettings.baseCardSets[i][j].strength} type="number" />
    protection <input class="w-9" bind:value={$currentSettings.baseCardSets[i][j].protection} type="number" />
    <br />
  {/each}
{/each}
<hr />
<hr class="border border-black" />
<hr />

<h2 class="font-bold text-xl">Gojira cards</h2>
{#each $currentSettings.gojiraCardSets as _, i}
  <h3 class="font-bold">Type {i}</h3>
  <ul>
    {#each $currentSettings.gojiraCardSets[i].set as _, j}
      <li>
        <span class="font-bold">{j}:</span>
        attack <input class="w-9" bind:value={$currentSettings.gojiraCardSets[i].set[j][0].attack} type="number" />
        defense <input class="w-9" bind:value={$currentSettings.gojiraCardSets[i].set[j][0].defense} type="number" />
        strength <input class="w-9" bind:value={$currentSettings.gojiraCardSets[i].set[j][0].strength} type="number" />
        protection
        <input class="w-9" bind:value={$currentSettings.gojiraCardSets[i].set[j][0].protection} type="number" />
      </li>
    {/each}
  </ul>
{/each}

<hr />
<hr class="border border-black" />
<hr />

<h2 class="font-bold text-xl">Otther Settings</h2>

<div>
  {#each Object.values($allSettings.list) as settings}
    <button class="border-black border-2 p-2 m-2" on:click={() => allSettings.use(settings.name)}>
      {settings.name}
    </button>
  {/each}
</div>

<button class="border-black border-2 p-2 m-2" on:click={() => allSettings.clear()}> CLEAR </button>

{#if $saveSettingsFlow.step === 'CONFIRM'}
  <Modal on:close={() => saveSettingsFlow.cancel()}>
    <p>Do you want to override the existing Settings named "{$currentSettings.name}"</p>
    <button class="border-2 border-black p-2 m-2" on:click={() => saveSettingsFlow.confirm()}>confirm</button>
  </Modal>
{/if}
